import React, { useState } from "react";
import ErrorModal from "./organisms/ErrorModal";
import { Button, Carousel, Spin } from "antd";
import Header from "./headerPhase2";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import axios from "axios";
import { useSelector } from "react-redux";
import homeIcon from "./../assets/img/home-icon.png";
import { resources } from "../resource";

const API_URL = process.env.REACT_APP_DEVELOPMENT_API_URL;

const FinancialTransaction = (props) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  const location = useLocation();

  const [apiErrorMessage, setApiErrorMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [payLater, setPayLater] = useState(false);
  const patientForm = useSelector((state) => state.patientForm);
  const _resources = resources[props?.language];

  const companyId =
    patientForm.patientForm.companyId ??
    patientForm.newPatientValidation.companyId;
  const aptID =
    patientForm.validationResponse.appointmentId ??
    patientForm.newPatientValidation.aptID;
  const apptDateTime =
    patientForm.validationResponse.appointmentDate ??
    patientForm.newPatientValidation.apptDateTime;
  const accountNumber =
    location.state.accountNo ??
    "C" + patientForm.newPatientValidation.patientId;
  const amountDue = location.state.amountDue;
  const doxyUrl = patientForm.validationResponse.doxyUrl;

  const WebhookUri =
    window.location.protocol +
    "//" +
    window.location.host +
    "/" +
    `patient-checkin/payment-confirmation?paymentguid={0}`;

  const payNow = async () => {
    if (amountDue == 0) {
      return;
    }
    setLoading(true);
    try {
      const apiUrl = `${API_URL}PatientPayments/PostWayStarSaleLinkInformation?CompanyId=${companyId}&AppointmentId=${aptID}&AppointmentDate=${apptDateTime}&AccountNumber=${accountNumber}&AmountDue=${amountDue}&WebhookUri=${WebhookUri}`;

      const response = await axios.post(apiUrl);
      if (
        response.status == 200 &&
        response.data.wayStarSaleLinkResponse.wayStarSaleLinkInformation
          .shortlink
      ) {
        window.location.href =
          response.data.wayStarSaleLinkResponse.wayStarSaleLinkInformation.shortlink;
      }
    } catch (err) {
      if (
        err.response.data.wayStarSaleLinkResponse &&
        err.response.data.wayStarSaleLinkResponse.wayStarSaleLinkInformation
          .status == "error"
      ) {
        setErrMsg(
          "An error occurred during payment processing.  Please visit the front desk.",
        );
      }
      setApiErrorMessage(true);
    } finally {
      setLoading(false);
    }
  };

  const renderCarousel = () => (
    <Carousel>
      {[
        "clinic-pic-one",
        "clinic-pic-two",
        "clinic-pic-three",
        "clinic-pic-four",
      ].map((pic, index) => (
        <div key={index}>
          <div className={pic}></div>
        </div>
      ))}
    </Carousel>
  );

  return (
    <>
      <ErrorModal
        visible={apiErrorMessage}
        onClose={() => setApiErrorMessage(false)}
        errorMessage={errMsg || "Something went wrong. Please try again later."}
      />
      <Header />
      <Helmet>
        <title>CORA Health | Amount Due</title>
      </Helmet>
      <div className="checkin-page-carousel d-flex justify-content-between">
        <div className="col-lg-7 submit-container">
          {payLater ? (
            <>
              <div className="appointment-booked-page ap-details-card text-center amount-due-card bg-white m-4">
                <h4 className={`${doxyUrl && 'mb-4'}`}>Thank you. Please proceed to front desk</h4>
                {doxyUrl && (
                  <a
                    className="verify-btn p-3"
                    href={doxyUrl}
                    target="_blank"
                    style={{ color: 'black', textDecoration: 'none' }}
                  >
                    {_resources.Submission.DOXYTEXT}
                  </a>
                )}
              </div>
              <a className="back-home mt-0" href="https://coraphysicaltherapy.com">
                <img src={homeIcon} alt="Home Icon" onClick={() => window.location.replace("https://coraphysicaltherapy.com")} />
                <p>{_resources.Submission.BACK_TO_HOME}</p>
              </a>
            </>
          ) : (
            <div className="appointment-booked-page ap-details-card text-center amount-due-card bg-white m-4">
              <h4>Thank you for choosing CORA</h4>
              <div className="text-lead mb-2">
                <h5>
                  You currently have a balance of ${location.state.amountDue}{" "}
                  due
                </h5>
              </div>
              <div className="d-flex gap-3 text-sm text-muted justify-content-center mb-2">
                <p className="mb-0 w-75">
                  Your amount due is a combination of any past due balance and
                  today's visit amount.<br /> The current visit due amount is your
                  estimated responsibility based on your chosen insurance plan
                </p>
              </div>
              <div className="d-flex gap-4 align-items-center mt-3">
                <Button
                  className="additional-info-btn align-items-center"
                  onClick={() => payNow()}
                  disabled={loading}
                >
                  {loading ? (
                    <Spin
                      indicator={antIcon}
                      className="mr-3 submit-btn-loader"
                    />
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-credit-card mr-2"
                    >
                      <rect width={20} height={14} x={2} y={5} rx={2} />
                      <line x1={2} x2={22} y1={10} y2={10} />
                    </svg>
                  )}{" "}
                  Pay Now
                </Button>
                {
                  patientForm.validationResponse.doxyUrl
                    ?
                    null
                    :
                    <Button
                      className="additional-info-btn d-inline-flex align-items-center justify-content-center gap-2 text-nowrap rounded fs-6 fw-medium transition focus:outline-0 border border-body bg-body h-10 px-4 py-2 w-100 w-sm-auto btn-pay-later"
                      onClick={() => setPayLater(true)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-clock mr-2"
                      >
                        <circle cx={12} cy={12} r={10} />
                        <polyline points="12 6 12 12 16 14" />
                      </svg>
                      Pay at Front Desk
                    </Button>
                }
              </div>
            </div>
          )}
        </div>
        <div className="col-lg-5 p-0 carousel-column">{renderCarousel()}</div>
      </div>
    </>
  );
};

export default FinancialTransaction;
